<template>
    <div class="container">
        <div class="card m-b-5" :style="'background-color: '+color" @mouseover="hover = true" @mouseleave="hover = false">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12 btn btn-link workhour-button" :class="{ hidden: !editable || !hover }">
                        <div data-toggle="modal" :data-target="'#'+editModalId">Edytuj</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        {{fromHour}}<sup>{{fromMinute}}</sup> – {{toHour}}<sup>{{toMinute}}</sup>
                        <br><small><b>{{getWeekParityAbbr()}}</b></small>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 btn btn-link workhour-button red-button" :class="{ hidden: !editable || !hover }">
                        <div @click="deletePlan">Usuń</div>
                    </div>
                </div>
            </div>

        </div>
        <div v-if="editable">
            <WorktimeFormModal
                    :modalId="editModalId"
                    :dow="plan.dow"
                    :fromTimeValueDefault="fromTimeString"
                    :toTimeValueDefault="toTimeString"
                    :places="places"
                    :plan="plan"
                    @updated="data => $emit('updated', data)">
            </WorktimeFormModal>
        </div>


    </div>
</template>

<script>
    import {backend} from '../../backend';
    import Constants from '../../constants.js';

    import WorktimeFormModal from './WorktimeFormModal.vue'

    export default {
        name: "WorktimeEditableHour",
        components: {WorktimeFormModal},
        props: {
            plan: {
                type: Object,
                required: true
            },
            places: {
                type: Array,
                required: true
            },
            editable: {
                type: Boolean,
                required: true
            },
            color: String,
        },
        data() {
            return {
                hover: false,
            }
        },
        methods: {
            padTime: num => num.toString().padStart(2, '0'),
            getHour: time => Math.floor(time / 60),
            getMinute: time => time % 60,
            getWeekParityAbbr() {
                return Constants.get('IA_WORKPLAN_WEEK_PARITY')[this.plan.week_id].abbr;
            },
            deletePlan() {
                backend.deleteWorktimePlan(this.plan.id)
                    .then(() => {
                        this.$emit('deleted', this.plan);
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się usunąć planu.', color: 'danger'});
                    })
            }
        },
        computed: {
            editModalId: function () {
                return 'editModal' + this.plan.id
            },
            fromTimeString: function () {
                return this.padTime(this.fromHour) + ':' + this.fromMinute;
            },
            toTimeString: function () {
                return this.padTime(this.toHour) + ':' + this.toMinute;
            },
            fromHour: function () {
                return this.getHour(this.plan.from_hour);
            },
            toHour: function () {
                return this.getHour(this.plan.to_hour);
            },
            fromMinute: function () {
                return this.padTime(this.getMinute(this.plan.from_hour));
            },
            toMinute: function () {
                return this.padTime(this.getMinute(this.plan.to_hour));
            },
        }

    }
</script>

<style scoped>
    .card-body {
        padding: 0;
        margin: 0;
    }

    .workhour-button {
        font-size: small;
        padding: 0;
        margin: 0;
    }

    .hidden {
        visibility: hidden;
    }
    .red-button, .red-button:hover {
        color: red;
    }
</style>


// WEBPACK FOOTER //
// WorktimeEditableHour.vue?b8ccd3c2